import React from 'react';
import request from '../../../request';
import { Link } from 'react-router-dom';

export default class Files extends React.Component {
  constructor() {
    super();
    this.state = {};
  }
  render() {
    let { loading } = this.state;
    let type = localStorage.getItem('type');
    let userId = parseInt(localStorage.getItem('user_id'), 10);
    let {
      study,
      claim,
      canDownloadStudy,
      canDownloadResults,
      canDownloadReport,
    } = this.props;
    return (
      <div id="files" style={{ opacity: loading ? 0.5 : 1 }}>
        {study.status === 'pending' ? (
          <div className="cover">
            {type === 'admin' || type === 'staff' ? (
              <div
                className="action"
                onClick={() => (claim ? claim(true) : null)}
                style={{ opacity: claim ? 1 : 0.5 }}
              >
                Claim Study
              </div>
            ) : null}
          </div>
        ) : null}
        {canDownloadStudy ? (
          <div className="item ss-attach">
            <a
              href="#study"
              onClick={async e => {
                e.preventDefault();
                if (loading) return;
                this.setState({ loading: true });

                let response = await request({
                  url: `studies/${study.id}/download`,
                  method: 'POST',
                });
                this.setState({ loading: false });

                if (!response)
                  return alert('Study not available at this time.');
                window.location = response.url;
              }}
            >
              Study
            </a>
            <span>{study.study_file_size}</span>
          </div>
        ) : (
          <div className="item ss-attach low">
            <strong>Study</strong>
            <span>
              {!study.study_download_path && study.study_file_size ? (
                'Checksum'
              ) : (
                'N/A'
              )}
            </span>
          </div>
        )}

        {canDownloadResults && study.results_download_path ? (
          <div className="item ss-attach admin">
            <a
              onClick={async e => {
                e.preventDefault();
                if (loading) return;
                this.setState({ loading: true });

                let response = await request({
                  url: `studies/${study.id}/results/download`,
                  method: 'POST',
                });
                this.setState({ loading: false });
                if (!response)
                  return alert('Study not available at this time.');
                window.location = response.url;
              }}
              href="#results"
            >
              Results
            </a>
            {type === 'admin' || type === 'company admin' ? (
              <Link
                className="remove ss-delete"
                to={`/study/${study.id}/results`}
              />
            ) : null}
            <span>{study.results_file_size}</span>
          </div>
        ) : (type === 'admin' || userId === study.scored_by_user_id) &&
        !study.results_download_path ? (
          <Link className="add ss-plus" to={`/study/${study.id}/results`}>
            {!study.results_download_path && study.results_file_size ? (
              'Results (Checksum Error)'
            ) : (
              'Upload Results'
            )}
          </Link>
        ) : (
          <div className="item ss-attach low">
            <strong>Results</strong>
            <span>N/A</span>
          </div>
        )}

        {canDownloadReport && study.report_download_path ? (
          <div className="item ss-attach admin">
            <a
              onClick={async e => {
                e.preventDefault();
                if (loading) return;
                this.setState({ loading: true });

                let response = await request({
                  url: `studies/${study.id}/report/download`,
                  method: 'POST',
                });
                this.setState({ loading: false });

                if (!response)
                  return alert('Study not available at this time.');
                window.location = response.url;
              }}
              href="#report"
            >
              Report
            </a>
            {type === 'admin' || type === 'company admin' ? (
              <Link
                className="remove ss-delete"
                to={`/study/${study.id}/report`}
              />
            ) : null}
            <span>{study.report_file_size}</span>
          </div>
        ) : (type === 'admin' || userId === study.scored_by_user_id) &&
        !study.report_download_path ? (
          <Link className="add ss-plus" to={`/study/${study.id}/report`}>
            {!study.report_download_path && study.report_file_size ? (
              'Report (Checksum Error)'
            ) : (
              'Upload Report'
            )}
          </Link>
        ) : (
          <div className="item ss-attach low">
            <strong>Report</strong>
            <span>N/A</span>
          </div>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/dashboard/components/files.js